module.exports = __webpack_public_path__ + "img/pr.2194db18.png";